import { EditorView } from "@codemirror/view";

export const YamlConfig = [
  EditorView.lineWrapping,
  EditorView.theme({
    "&": { fontSize: "14px", fontFamily: "monospace" },
    ".cm-lineNumbers": { display: "block" },
  }),
];

export const YAML_SIZE = "500px";

export const DEFAULT_YAML = `rules:
- path: "PATH"
  name: "FIELDNAME"
  action: "ADD_FIELD"
  properties:
    name: "NAME"
    type: "text"
    hidden: false
    required: false
    writable: false
`;
